import React, { useEffect, useState } from 'react';
import { FiFile } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import CheckBox from './CheckBox';
import DropdownActions from './DropdownActions';
import Loader from './Loader';

const Table = ({
  colunas,
  dados,
  onAcaoClick,
  renderizarStatus,
  renderizarConteudo,
  onRowClick,
}) => {
  const navigate = useNavigate();

  const handleProntuarioClick = (item) => {
    navigate(`/record?id=${item.id}`);
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full overflow-x-auto rounded-md border border-slate-100">
      <div className="min-w-max">
      <table className="min-w-max w-full table-auto text-sm bg-white">
        <thead>
          <tr className="text-gray-500 text-xs font-medium border-b border-slate-100 bg-white">
            {colunas.map((coluna, index) => (
              <th
                key={index}
                className={`
                  ${coluna.apenasDesktop ? 'hidden sm:table-cell' : ''}
                  px-2 sm:px-4 py-3 capitalize font-medium text-left
                  ${coluna.align === 'center' || coluna.centralizado ? 'text-center' : ''}
                `}
              >
                {typeof coluna.titulo === 'string' ? coluna.titulo.toLowerCase() : coluna.titulo}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={colunas.length}>
                <div className="flex justify-center items-center h-32">
                  <Loader width="w-6" height="h-6" />
                </div>
              </td>
            </tr>
          ) : (
            dados.map((item, itemIndex) => (
            <tr
              key={itemIndex}
              onClick={() => onRowClick && onRowClick(item)}
              className={itemIndex === dados.length - 1 ? '' : 'border-b border-slate-100'}
            >
              {colunas.map((coluna, colunaIndex) => (
                <td
                  key={colunaIndex}
                  className={`
                    ${coluna.apenasDesktop ? 'hidden sm:table-cell' : ''}
                    px-2 sm:px-4 py-3 text-gray-700 text-xs align-middle
                    ${coluna.align === 'center' || coluna.centralizado ? 'text-center' : ''}
                    ${coluna.tipo === 'prontuario' && item[coluna.campo] ? 'cursor-pointer' : ''}
                  `}
                  onClick={coluna.tipo === 'prontuario' && item[coluna.campo]
                    ? (e) => {
                        e.stopPropagation();
                        handleProntuarioClick(item);
                      }
                    : undefined
                  }
                >
                  {renderizarConteudo
                    ? renderizarConteudo(coluna, item)
                    : renderConteudoPadrao(coluna, item, onAcaoClick, renderizarStatus)}
                </td>
              ))}
            </tr>
              ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export const renderConteudoPadrao = (coluna, item, onAcaoClick, renderizarStatus) => {
  const valor = item[coluna.campo];

  if (coluna.tipo === 'status' && renderizarStatus) {
    return renderizarStatus(valor);
  }

  if (coluna.tipo === 'prontuario') {
    return valor ? (
      <div className="flex justify-center hover:bg-gray-100 transition-colors duration-3000 rounded-2xl">
        <div className="p-1 rounded-full"  title='Prontuário'>
          <FiFile size={18} className="text-gray-500" />
        </div>
      </div>
    ) : null;
  }

  if (coluna.tipo === 'acao' || coluna.tipo === 'acoes') {
    const acoes = item.acoes || [];
    
    if (acoes.length === 0) {
      return '—';
    }
    
    if (acoes.length === 1) {
      const acao = acoes[0];
      return (
        <div className="flex justify-center">
          <button
            className="text-gray-500 flex items-center justify-center h-6 w-6 rounded-full hover:bg-gray-100"
            onClick={(e) => {
              e.stopPropagation();
              acao.onClick ? acao.onClick() : onAcaoClick && onAcaoClick(item, acao);
            }}
            title={acao.label}
          >
            <acao.icon className="text-gray-500 text-base" />
          </button>
        </div>
      );
    }
    
    return (
      <div className="flex justify-center">
        <DropdownActions actions={acoes} />
      </div>
    );
  }

  if (coluna.tipo === 'checkbox') {
    return (
      <CheckBox
        onClick={(e) => e.stopPropagation()}
      />
    );
  }

  return valor || '—';
};

export default Table;